import wx from 'weixin-js-sdk'
import store from '../store'
import { fetchShareAuth } from '../api/user'
const APPID = 'wx1db913615503aab7'

const wxutil = {
  init() {
    fetchShareAuth({
      // TODO 取消注释
      url: location.href.replace(/#.*$/, ''),
    }).then((res) => {
      if (this.isValidResp(res)) {
        // 获取微信公众号jssdk配置信息成功,上报
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: APPID, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline', // 分享到微信朋友圈
            'onMenuShareAppMessage', // 分享给微信朋友
            'onMenuShareQQ', // 分享到QQ
            'onMenuShareQZone', // 分享到QQ空间
            'updateAppMessageShareData', // 分享到微信及QQ（新接口）
            'updateTimelineShareData'], // 必填，需要使用的JS接口列表
        })
        wx.ready(() => {
          console.log('加载微信 js-sdk 完毕')
          // 更新微信 js-sdk 的加载状态
          store.dispatch('updateWxSdkLoadStatus', true)
        })
        wx.error((error) => {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.warn('加载微信 js-sdk 失败: ', error)
          // 更新微信 js-sdk 的加载状态
          store.dispatch('updateWxSdkLoadStatus', false)
        })
      }
    }).catch((e) => {
      console.log('fetchShareAuth err: ', e)
    })
  },
  isValidResp(res) {
    return res.resp_common && res.resp_common.ret === 0
  },
}
export default wxutil
